var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hud"},[_vm._m(0),_c('progress-bar-step',{attrs:{"value":_vm.hp*10,"hue":350,"withoutColor":true}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paddingRound"},[_c('h2',[_c('i',{staticClass:"fas fa-heart"})])])
}]

export { render, staticRenderFns }